__turbopack_context__.v({
  "banner": "iTMAFa_banner",
  "content": "iTMAFa_content",
  "lockIcon": "iTMAFa_lockIcon",
  "text": "iTMAFa_text",
});
